const DATE_FORMAT = 'yyyy-MM-dd'

export { DATE_FORMAT }
